import { Nav, Tab } from "react-bootstrap";
import { Icon, LoadingIndicator, RenderWhen } from "../../../components";
import Typography from "../../../components/typography/Typography";
import { ReportSummaryHeader } from "../components";
import AttributionTabContent from "../components/ioc/AttributionTabContent";
import MalwareFamilyInsightsTabContent from "../components/ioc/MalwareFamilyInsightsTabContent";
import useGetIOCSummary from "../hooks/useGetIOCSummary";

interface ThreatIntelligenceContainerProps {
  ioc: string;
  threatName?: string;
  sourceId?: number;
  showHeader?: boolean;
  isDataLoading?: boolean;
}

const ThreatIntelligenceContainer = ({
  ioc,
  threatName,
  sourceId,
  showHeader = true,
  isDataLoading = false
}: ThreatIntelligenceContainerProps) => (
  <div className="flex flex-column flex-gap-5">
    {showHeader && <ReportSummaryHeader />}
    <RenderWhen condition={!isDataLoading} fallback={<LoadingIndicator />}>
      <div className="flex flex-gap-2 flex-center">
        <Icon name="cloud-intelligence" size={24} />
        <Typography variant="h2">Attribution Data</Typography>
      </div>
      <div>
        <Tab.Container defaultActiveKey="attribution">
          <Nav variant="tabs" className="nav-tabs--bordered">
            <Nav.Item>
              <Nav.Link eventKey="attribution">Attribution</Nav.Link>
            </Nav.Item>
            <Nav.Item>
              <Nav.Link eventKey="malware-family">
                Malware Family Insights
              </Nav.Link>
            </Nav.Item>
          </Nav>
          <Tab.Content>
            <Tab.Pane eventKey="attribution">
              <AttributionTabContent ioc={ioc} threatName={threatName} />
            </Tab.Pane>
            <Tab.Pane eventKey="malware-family">
              <MalwareFamilyInsightsTabContent
                ioc={ioc}
                threatName={threatName}
                sourceId={sourceId}
              />
            </Tab.Pane>
          </Tab.Content>
        </Tab.Container>
      </div>
    </RenderWhen>
  </div>
);

export default ThreatIntelligenceContainer;
